// snow.js

export function startSnow(canvas) {
  const ctx = canvas.getContext("2d");

  let snowflakes = [];
  const numFlakes = 70;

  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;

  let snowStart = canvas.height * 0.1; // 10vh
  let snowLimit = canvas.height * 0.5; // 50vh

  class Snowflake {
    constructor() {
      this.x = Math.random() * canvas.width;
      this.y = Math.random() * (snowLimit - snowStart) + snowStart;
      this.radius = Math.random() * 3 + 1;
      this.speedY = Math.random() * 0.8 + 0.2;
      this.speedX = Math.random() * 1 - 0.5;
    }

    update() {
      this.y += this.speedY;
      this.x += this.speedX;

      if (this.y > snowLimit) {
        this.y = snowStart - 5;
        this.x = Math.random() * canvas.width;
      }

      if (this.x > canvas.width) this.x = 0;
      if (this.x < 0) this.x = canvas.width;
    }

    draw() {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
      ctx.fillStyle = "white";
      ctx.fill();
    }
  }

  for (let i = 0; i < numFlakes; i++) {
    snowflakes.push(new Snowflake());
  }

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    snowflakes.forEach((flake) => {
      flake.update();
      flake.draw();
    });

    requestAnimationFrame(animate);
  }

  animate();

  window.addEventListener("resize", () => {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    snowStart = canvas.height * 0.1;
    snowLimit = canvas.height * 0.5;
  });
}